import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";

import NotFound from "./NotFound";
import Nav from "./Nav/Nav";
import HomePage from "./landing/Home";
import SignUpPage from "./account/SignUp";
import SignInPage from "./account/SignIn";
import PasswordForgetPage from "./account/PasswordForget";
import AccountPage from "./Account";
import withAuthentication from "./withAuthentication";
import SelectInterestsPage from "./account/SelectInterests";
import FeaturePage from "./features/Features";
import * as routes from "../constants/routes";

const App = () => (
  <BrowserRouter>
    <div className="h-100">
      <Nav />

      <Switch>
        <Route path="/" component={HomePage} />
        <Route exact path={routes.SIGN_UP} component={SignUpPage} />
        <Route exact path={routes.SIGN_IN} component={SignInPage} />
        <Route exact path={routes.PASSWORD_FORGET} component={PasswordForgetPage} />
        <Route exact path={routes.HOME} component={HomePage} />
        <Route exact path={routes.ACCOUNT} component={AccountPage} />
        <Route exact path={routes.SELECT_INTERESTS} component={SelectInterestsPage} />
        <Route path={routes.FEATURE} component={FeaturePage} />
        <Route component={NotFound} />
      </Switch>
    </div>
  </BrowserRouter>
);

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App.js